<!-- <div class="footer">
	<p>
		<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37021202000564" style="display:inline-block;text-decoration:none;height:30px;line-height:30px;">
			<img src="/static/images/gongan_icon.png" style="position: relative;top:3px" />
	        <span style="display:inline-block;color:#939393;">鲁公网安备 37021202000564号</span>
	    </a>
	    <a style="display:inline-block;text-decoration:none;height:30px;line-height:30px;">
	    	<span style="display:inline-block;margin: 0px 0px 0px 15px;color:#939393;">青岛海尔保险代理有限公司</span>
	    </a>
	</p>
	<p>Copyright©2017-2021 www.haierbx.net All Rights Reserved.　|　<a style="color:#999" href="http://beian.miit.gov.cn">鲁ICP备17039839号-1</a></p>
</div> -->
<style scoped>
	/* .footer{
		background: #414141;
		padding: 20px 0;
		text-align: center;
		color: #999;
		font-size: 12px;
	} */
</style>
<template>
    <div class="layout-footer">
		<div class="main">
			<div class="foot-top">
				<ul>
					<li>
						<div style="margin-top: 8px;">
							<!-- <img v-if="host.indexOf('qzg001.com')>-1" src="/static/images/common/logo3.png" alt="" width="120"> -->
							<img src="/static/images/common/logo-footer-zm.png" alt="" width="120">
						</div>
					</li>
					<!-- <li> 
						<p><span class="num">20</span>年</p>
						<p>专业保险服务</p>
					</li> -->
					<li>
						<p><span class="num">80</span></p>
						<p>保险公司合作伙伴</p>
					</li>
					<!-- <li>
						<p><span class="num">270</span>+</p>
						<p>产品签约</p>
					</li> -->
					<li>
						<p><span class="num counter" data-counter-time="0" data-counter-delay="50">311000</span>+</p>
						<p>注册用户数</p>
					</li>
					<li>
						<p><span class="num counter" data-counter-time="0" data-counter-delay="50">37000</span>+</p>
						<p>企业保险用户</p>
					</li>
					<li>
						<p><span class="num">626000</span>+</p>
						<p>家庭保险用户</p>
					</li>
				</ul>
			</div>
			<div class="foot-mid">
				<ul>
					<li>
						<p class="ftitle">客户服务</p>
						<p class="num">400-100-0316</p>
						<p>全国服务热线</p>
					</li>
					<!-- <li>
						<p class="ftitle">客户服务</p>
						<p>掌柜简介</p>
						<p>企业文化</p>
						<p>发展历史</p>
						<p>荣誉奖项</p>
					</li>
					<li>
						<p class="ftitle">平台资讯</p>
						<p>掌柜动态</p>
						<p>行业咨询</p>
						<p>机构动态</p>
						<p>热门话题</p>
					</li> -->
					<li style="display:flex;justify-content: space-around;">
						<div>
							<p class="ftitle">官方公众号</p>
							<div class="" style="margin-top:5px">
								<img src="/static/images/common/wechat.jpg" alt="" width="115">
							</div>
						</div>
						<div>
							<p class="ftitle">官方APP</p>
							<div class="" style="margin-top:5px">
								<img src="/static/images/common/app.jpg" alt="" width="115">
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div class="foot-bot">
				
				<template v-if="host=='www.qzg001.com'||host=='qzg001.com'">
					Copyright © &nbsp;青岛海尔保险代理有限公司&nbsp;&nbsp; www.qzg001.com&nbsp;&nbsp; All Rights Reserved.　|　
					<a style="color:#999" target="_blank" href="http://beian.miit.gov.cn">鲁ICP备17039839号-2</a>   |
					<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37021202000354" style="display:inline-block;text-decoration:none;height:30px;line-height:30px;">
						<img src="/static/images/gongan_icon.png" style="position: relative;top:3px" />
						<span style="display:inline-block;color:#939393;">鲁公网安备 37021202000354号</span>
					</a> 
				</template>
				<template v-else-if="host=='www.zonemio.com'||host=='zonemio.com'">
					Copyright © &nbsp;众淼控股（青岛）股份有限公司&nbsp;&nbsp; www.zonemio.com&nbsp;&nbsp; All Rights Reserved.　|　
					<a style="color:#999" target="_blank" href="http://beian.miit.gov.cn">鲁ICP备2023001641号</a>   |
					<!-- <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37021202000354" style="display:inline-block;text-decoration:none;height:30px;line-height:30px;">
						<img src="@/assets/images/common/gongan_icon.png" style="position: relative;top:3px" />
						<span style="display:inline-block;color:#939393;">鲁公网安备 37021202000354号</span>
					</a>  -->
				</template>
				<template v-else>
					Copyright © &nbsp;青岛海尔保险代理有限公司&nbsp;&nbsp; www.haierbx.net&nbsp;&nbsp; All Rights Reserved.　|　
					<a style="color:#999" target="_blank" href="http://beian.miit.gov.cn">鲁ICP备17039839号-1</a>   |
					<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37021202000564" style="display:inline-block;text-decoration:none;height:30px;line-height:30px;">
						<img src="/static/images/gongan_icon.png" style="position: relative;top:3px" />
						<span style="display:inline-block;color:#939393;">鲁公网安备 37021202000564号</span>
					</a> 
				</template>
				
			</div>	
		</div>
    </div>
</template>
<script>

export default {
    props: ["value"],
    data() {
        return {
           host:''
        };
    },
    methods: {
        
    },
    mounted() {
       	this.host = location.host
    }
};
</script>
<style lang="less" scoped>
.layout-footer{
	width: 100%;
	background: #182a4f;
	font-size: 14px;
	.main{
		background: #182a4f;
		color: #fff;
		.foot-top{
			ul{
				display: flex;
				justify-content: space-evenly;
				border-bottom: 1px solid #465472;
				padding: 38px 0;
				li{
					text-align: center;
					width: 100%;
					p{
						font-size: 14px;
						span{
							font-size: 24px;
						}
					}
				}
				li+li{
					border-left: 1px solid #465472;
				}
			}
		}
		.foot-mid{
			ul{
				display: flex;
				justify-content: space-evenly;
				padding: 38px 0;
				border-bottom: 1px solid #465472;
				li{
					width: 100%;
					p{
						font-size: 14px;
						line-height: 28px;
					}
					.ftitle{
						font-size: 16px;
					}
					.num{
						font-size: 28px;
						line-height: 50px;
					}
				}
			}
		}
		.foot-bot{
			line-height: 58px;
			text-align: center;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue